import { jsx as C } from "react/jsx-runtime";
import "react";
var i = (e) => /* @__PURE__ */ C("svg", {
  width: "100%",
  height: "100%",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ...e,
  children: /* @__PURE__ */ C("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0406 28.6576C9.89198 28.552 9.68727 28.5806 9.56275 28.714C7.89836 30.496 3.6388 31.746 3.44369 29.3138C3.44369 27.4082 3.01732 25.8024 2.54787 24.0343C1.97293 21.8689 1.33337 19.4602 1.33337 15.9594C1.33337 7.61139 8.15359 1.33325 16.2401 1.33325C24.3265 1.33325 30.6667 7.91791 30.6667 16.0405C30.6667 24.1631 24.1247 30.5856 16.3166 30.5856C13.5464 30.5856 12.2022 30.1939 10.0406 28.6576ZM16.4669 8.57144C12.6293 8.36942 9.63457 11.0425 8.9742 15.2264C8.42732 18.6912 9.39692 22.913 10.2263 23.1255C10.578 23.2157 11.4245 22.5657 12.0404 21.9827C12.1562 21.8731 12.3313 21.8547 12.467 21.938C13.4271 22.5273 14.514 22.9702 15.7123 23.0333C19.6521 23.2407 23.1434 20.1454 23.3498 16.1902C23.5561 12.235 20.4066 8.77883 16.4669 8.57144Z",
    fill: "currentColor"
  })
});
export {
  i as default
};
